// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import './Tab.scss';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

interface Props {
  className?: string;
  tabItems: string[];
  defaultTabIndex: number;
  renderContent: (item: { index: number; tab: string }) => React.ReactNode;
  setTabIndex?: (tabIndex: number) => void;
}

export const Tab = ({
  className,
  tabItems,
  defaultTabIndex,
  renderContent,
  setTabIndex,
}: Props) => {
  const [activedTabIndex, setActivedTabIndex] = useState(
    defaultTabIndex ? defaultTabIndex : 0
  );
  useEffect(() => {
    if (setTabIndex) {
      setTabIndex(activedTabIndex);
    }
  }, [activedTabIndex]);
  const history = useHistory();

  useEffect(() => {
    if (history.location.hash !== '#1') {
      setActivedTabIndex(0);
      location.replace('#0');
    }
  }, [history.location.hash]);

  return (
    <div className={className}>
      <div className="tab-menu">
        <div className="tab-items">
          {tabItems.map((it, index) => {
            const actived = index === activedTabIndex;
            return (
              <div
                key={it}
                className={'tab-item ' + (actived ? 'active' : '')}
                onClick={() => {
                  setActivedTabIndex(index);
                  history.push(`${window.location.search}#` + index);
                }}
              >
                {it}
              </div>
            );
          })}
        </div>
      </div>
      <div className="tab-container">
        {tabItems.map((tab, index) => (
          <div
            key={`tab-content-${index}`}
            className={index !== activedTabIndex ? 'hidden' : ''}
          >
            {renderContent({ index, tab })}
          </div>
        ))}
      </div>
    </div>
  );
};
